import { render, staticRenderFns } from "./mxn.vue?vue&type=template&id=76b89bb8&scoped=true"
import script from "./mxn.vue?vue&type=script&lang=js"
export * from "./mxn.vue?vue&type=script&lang=js"
import style0 from "./mxn.vue?vue&type=style&index=0&id=76b89bb8&prod&lang=css"
import style1 from "./mxn.vue?vue&type=style&index=1&id=76b89bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b89bb8",
  null
  
)

export default component.exports